import {addNotification} from '../redux/actions/application';

export const handleError = (e) => {
    return (dispatch) => {
        dispatch(addNotification({message: e.message, type: 'error'}));
    };
};
